import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './PrimeiroAcesso.css';

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

function PrimeiroAcesso() {
  const { user, clientSideLogout } = useAuth();
  const navigate = useNavigate();
  const [perfil, setPerfil] = useState({
    first_name: user?.first_name || '',
    last_name: user?.last_name || '',
  });
  const [senhas, setSenhas] = useState({
    old_password: '',
    new_password: '',
    confirm_password: '',
  });
  const [showSenha, setShowSenha] = useState(false);
  const [loading, setLoading] = useState(false);
  const csrfHeaders = { headers: { 'X-CSRFToken': getCookie('csrftoken') } };

  const handlePerfilChange = (e) => {
    const { name, value } = e.target;
    setPerfil(p => ({ ...p, [name]: value }));
  };

  const handleSenhaChange = (e) => {
    const { name, value } = e.target;
    setSenhas(p => ({ ...p, [name]: value }));
  };

  // Salvar perfil e ir para o sistema
  const handleSalvarPerfil = async (e) => {
    e.preventDefault();
    if (!perfil.first_name.trim() || !perfil.last_name.trim()) {
      toast.error('Preencha nome e sobrenome.');
      return;
    }
    setLoading(true);
    try {
      await axios.put('/api/meu-perfil/atualizar/', perfil, csrfHeaders);
      toast.success('Bem-vindo ao CBACV 2026!');
      // Recarrega a página para atualizar o contexto com o novo nome
      window.location.reload();
    } catch (err) {
      toast.error('Erro ao salvar perfil. Tente novamente.');
    }
    setLoading(false);
  };

  // Alterar senha (opcional)
  const handleAlterarSenha = async (e) => {
    e.preventDefault();
    if (senhas.new_password !== senhas.confirm_password) {
      toast.error('As senhas não coincidem.');
      return;
    }
    if (senhas.new_password.length < 6) {
      toast.error('A nova senha deve ter ao menos 6 caracteres.');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/api/change-password/', {
        old_password: senhas.old_password,
        new_password: senhas.new_password,
      }, csrfHeaders);
      toast.success('Senha alterada! Faça login novamente.');
      clientSideLogout();
      navigate('/login');
    } catch (err) {
      if (err.response?.data?.old_password) {
        toast.error('Senha atual incorreta.');
      } else {
        toast.error('Erro ao alterar senha. Tente novamente.');
      }
    }
    setLoading(false);
  };

  return (
    <div className="pa-overlay">
      <div className="pa-container">
        <div className="pa-card">
          <div className="pa-icon">👤</div>
          <h2 className="pa-title">Bem-vindo, {user?.username}!</h2>
          <p className="pa-desc">Por favor, informe seu nome para continuar.</p>

          {/* Formulário de perfil */}
          <form onSubmit={handleSalvarPerfil} className="pa-form">
            <div className="pa-form-row">
              <div className="pa-field">
                <label>Nome *</label>
                <input
                  name="first_name"
                  value={perfil.first_name}
                  onChange={handlePerfilChange}
                  placeholder="Seu primeiro nome"
                  required
                  autoFocus
                />
              </div>
              <div className="pa-field">
                <label>Sobrenome *</label>
                <input
                  name="last_name"
                  value={perfil.last_name}
                  onChange={handlePerfilChange}
                  placeholder="Seu sobrenome"
                  required
                />
              </div>
            </div>

            {/* Sugestão de troca de senha */}
            <div className="pa-senha-sugestao">
              <div className="pa-senha-sugestao-header" onClick={() => setShowSenha(!showSenha)}>
                <span>🔑 Deseja trocar sua senha agora? <span className="pa-opcional">(opcional)</span></span>
                <span className="pa-toggle">{showSenha ? '▲ Ocultar' : '▼ Mostrar'}</span>
              </div>
              <p className="pa-senha-dica">Recomendado para maior segurança no primeiro acesso.</p>

              {showSenha && (
                <div className="pa-senha-campos">
                  <div className="pa-field">
                    <label>Senha Atual</label>
                    <input
                      name="old_password"
                      type="password"
                      value={senhas.old_password}
                      onChange={handleSenhaChange}
                      placeholder="Senha fornecida pelo administrador"
                    />
                  </div>
                  <div className="pa-field">
                    <label>Nova Senha</label>
                    <input
                      name="new_password"
                      type="password"
                      value={senhas.new_password}
                      onChange={handleSenhaChange}
                      placeholder="Mínimo 6 caracteres"
                    />
                  </div>
                  <div className="pa-field">
                    <label>Confirmar Nova Senha</label>
                    <input
                      name="confirm_password"
                      type="password"
                      value={senhas.confirm_password}
                      onChange={handleSenhaChange}
                      placeholder="Repita a nova senha"
                    />
                  </div>
                  <button
                    type="button"
                    className="pa-btn-senha"
                    onClick={handleAlterarSenha}
                    disabled={loading || !senhas.old_password || !senhas.new_password}
                  >
                    🔑 Alterar Senha
                  </button>
                </div>
              )}
            </div>

            <button type="submit" className="pa-btn" disabled={loading}>
              {loading ? 'Salvando...' : '✓ Entrar no Sistema'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PrimeiroAcesso;
